export default __webpack_public_path__ + "static/media/destin.afbae89a.svg";